import script from "./security-event-statistics-cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./security-event-statistics-cards.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__